import React from 'react';
import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';
import useWindowDimensions from 'hooks/useWindowDimensions';
import HyperLink from 'components/Core/HyperLink';
import handleSamePathClick from '../utils/handleSamePathClick';

import { MenuItemContainer } from './styles';

const MenuItem = ({
  children,
  type,
  title,
  link,
  hasSubMenu,
  isMenuOpened,
  setIsMenuOpened,
  setMobileMenuOpened,
  ...otherProps
}) => {
  const windowWidth = useWindowDimensions().innerWidth;
  const isBurgerMenu = windowWidth <= 1240;

  const handleMenuClick = () => {
    handleSamePathClick(link, setMobileMenuOpened);
    setIsMenuOpened && setIsMenuOpened(!isMenuOpened);
  };
  const MenuContent = () => (
    <>
      {title} <CaretUpFilled style={{ fontSize: '14px' }} />
      <CaretDownFilled style={{ fontSize: '12px', position: 'relative' }} />
    </>
  );
  return (
    <MenuItemContainer
      type={type}
      className={
        (hasSubMenu ? ' has-child' : '') +
        (isMenuOpened ? ' website-header--menu-item--opened' : '')
      }
      isMenuOpened={isMenuOpened}
      style={{ display: otherProps.display && 'none' }}
    >
      <div className="menu-item--parent-link" onClick={() => handleMenuClick()}>
        {hasSubMenu ? (
          link === '#' || isBurgerMenu ? (
            <MenuContent />
          ) : (
            <HyperLink data-position="Header - Menu Item CTA" href={link}>
              <MenuContent />
            </HyperLink>
          )
        ) : (
          <HyperLink href={link || `tel: ${title}`}>{title}</HyperLink>
        )}
      </div>
      {children}
    </MenuItemContainer>
  );
};

export default MenuItem;
